module.exports = __webpack_public_path__ + "img/props.3aa9fb59.png";